<nav class="navbar">
  <div class="container-fluid">
    <div class="d-flex justify-content-between w-100 align-items-center">
      <a routerLink="healthcare">
        <img src="assets/images/header-icon/bluelogo.svg" alt="logo" class="w-100 px-3">
      </a>
      <button class="navbar-toggler collapsed btnmenu" type="button" data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
        aria-label="Toggle navigation">
        <span>
          <i class="fas fa-bars check" class="menu py-1" alt="ALFA"></i>
          <img src="assets/images/menu.svg" alt="logo" class="menu py-1">
        </span>
      </button>
    </div>

    <div class="collapse navbar-collapse body" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"
      id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="d-flex justify-content-between align-items-center container-fluid">
          <img src="assets/images/header-icon/bluelogo.svg" alt="alfa-care" class="img-logo">
          <span type="button" style="text-align: end !important;" data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
            aria-label="Toggle navigation">
            <span>
              <img src="assets/images/closemenu.png" class="w-50 close p-1" alt="ALFA">
            </span>
          </span>
        </li>

        <li *ngIf="role">
          <a class="nav-link links-hover d-flex justify-content-between" data-bs-toggle="collapse"
            href="#collapseservicemainExample" role="button" aria-expanded="false"
            aria-controls="collapseservicemainExample">
            <div>
              <img src="assets/images/header-icon/healthcare.svg" class="svg" alt="services">
              <span>{{'services.hcSetting' | translate}}</span>
            </div>
            <div>
              <img src="assets/images/header-icon/dropdown.png" alt="AlFA" class="dropIcon" />
            </div>
          </a>

          <div class="collapse container space-collaps" id="collapseservicemainExample">
            <a class="nav-link links-hover" routerLink="healthcare" routerLinkActive="active">
              &nbsp; 1- &nbsp; {{'services.Health Care' | translate}}
            </a>
            <a class="nav-link links-hover" routerLink="Add-service-healthcare" routerLinkActive="active">
              &nbsp; 2- &nbsp; {{'services.Add-Service' | translate}}
            </a>
            <a class="nav-link links-hover" routerLink="requests" routerLinkActive="active">
              &nbsp; 3- &nbsp; {{'services.Pending orders' | translate}}
            </a>
            <a *ngIf="role" class="nav-link links-hover" routerLink="hc-services" routerLinkActive="active">
              &nbsp; 4- &nbsp; {{'services.get hc Service' | translate}}
            </a>
          </div>
        </li>


        <li *ngIf="role">
          <a class="nav-link links-hover d-flex justify-content-between" data-bs-toggle="collapse"
            href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample">
            <div>
              <img src="assets/images/header-icon/services.svg" class="svg" alt="services">
              <span>{{'services.services' | translate}}</span>
            </div>
            <div>
              <img src="assets/images/header-icon/dropdown.png" alt="AlFA" class="dropIcon" />
            </div>
          </a>

          <div class="collapse container space-collaps" id="collapseExample">
            <a class="nav-link links-hover" routerLink="service" routerLinkActive="active">
              &nbsp; 1- &nbsp; {{'services.list service' | translate}}</a>
            <a class="nav-link links-hover" routerLink="sub-service-List" routerLinkActive="active">
              &nbsp; 2- &nbsp; {{'services.anotherservice' | translate}}
            </a>
            <a *ngIf="role" class="nav-link links-hover" routerLink="pindind-sub-service" routerLinkActive="active">
              &nbsp; 3- &nbsp; {{'services.Pendingservice' | translate}}
            </a>
            <a *ngIf="role" class="nav-link links-hover" routerLink="new-services" routerLinkActive="active">
              &nbsp; 4- &nbsp; {{'services.new services' | translate}}
            </a>
          </div>
        </li>

        <li *ngIf="role">
          <a class="nav-link links-hover d-flex justify-content-between" data-bs-toggle="collapse"
            href="#categoriesExample" role="button" aria-expanded="false" aria-controls="categoriesExample">
            <div>
              <img src="assets/images/categories/categories.png" class="svg" alt="categories">
              <span>{{'categories.settings' | translate}}</span>
            </div>
            <div>
              <img src="assets/images/header-icon/dropdown.png" alt="AlFA" class="dropIcon" />
            </div>
          </a>

          <div class="collapse container space-collaps" id="categoriesExample">
            <a class="nav-link links-hover" routerLink="medical-specialties" routerLinkActive="active">
              &nbsp; 1- &nbsp; {{'categories.categories' | translate}}</a>
            <a class="nav-link links-hover" routerLink="sub-medical-specialties" routerLinkActive="active">
              &nbsp; 2- &nbsp; {{'categories.sub categories' | translate}}</a>
            <a class="nav-link links-hover" routerLink="doctors" routerLinkActive="active">
              &nbsp; 3- &nbsp;{{'doctors.doctors' | translate}}
            </a>
            <a class="nav-link links-hover" routerLink="positions" routerLinkActive="active">
              &nbsp; 4- &nbsp;{{'doctors.add position' | translate}}
            </a>
            <a class="nav-link links-hover" routerLink="join-request-doctors" routerLinkActive="active">
              &nbsp; 5- &nbsp;{{'doctors.pending doctor' | translate}}
            </a>
            <a class="nav-link links-hover" routerLink="versions-doctors" routerLinkActive="active">
              &nbsp; 6- &nbsp;{{'doctors.versions' | translate}}
            </a>
          </div>
        </li>

        <li *ngIf="role">
          <a class="nav-link links-hover d-flex justify-content-between" data-bs-toggle="collapse" href="#rejectExample"
            role="button" aria-expanded="false" aria-controls="rejectExample">
            <div>
              <img src="assets/images/header-icon/registers.svg" class="svg" alt="paitient request">
              <span>{{'requests.paitient request' | translate}}</span>
            </div>
            <div>
              <img src="assets/images/header-icon/dropdown.png" alt="AlFA" class="dropIcon" />
            </div>
          </a>

          <div class="collapse container space-collaps" id="rejectExample">
            <a class="nav-link links-hover" routerLink="get-register" routerLinkActive="active">
              &nbsp; 1- &nbsp; {{'Register.Register' | translate}}</a>
            <a class="nav-link links-hover" routerLink="rejected" routerLinkActive="active">
              &nbsp; 2- &nbsp;{{'requests.rejected' | translate}}
            </a>
          </div>
        </li>
        <li *ngIf="role">
          <a class="nav-link links-hover" routerLink="service-healthcare" routerLinkActive="active">
            <img src="assets/images/header-icon/AddService.svg" class="svg" alt="health service">
            <span>{{'services.health service' | translate}}</span>
          </a>
        </li>

        <li *ngIf="role">
          <a class="nav-link links-hover" routerLink="sub-service" routerLinkActive="active">
            <img src="assets/images/header-icon/viewSub.svg" class="svg" alt="sub-service">
            <span>{{'services.sub-service' | translate}}</span>
          </a>
        </li>

        <li *ngIf="role">
          <a class="nav-link links-hover" routerLinkActive="active" routerLink="users">
            <img src="assets/images/header-icon/user.svg" class="svg" alt="user">
            <span>{{'user.users' | translate}}</span>
          </a>
        </li>

        <li *ngIf="role">
          <a class="nav-link links-hover" routerLinkActive="active" routerLink="activity-logs">
            <img src="assets/images/orders/New Order@2x.png" class="svg" alt="activity logs">
            <span>{{'logs.activity-logs' | translate}}</span>
          </a>
        </li>

        <li *ngIf="role">
          <a class="nav-link links-hover" routerLinkActive="active" routerLink="offer">
            <img src="assets/images/header-icon/offers.svg" class="svg" alt="offers">
            <span>{{'requests.offers' | translate}}</span>
          </a>
        </li>

        <li *ngIf="role">
          <a class="nav-link links-hover d-flex justify-content-between" data-bs-toggle="collapse"
            href="#collapseBookingExample" role="button" aria-expanded="false" aria-controls="collapseBookingExample">
            <div>
              <img src="assets/images/orders/New Order@2x.png" class="svg" alt="orders">
              <span>{{'booking.booking' | translate}}</span>
            </div>
            <div>
              <img src="assets/images/header-icon/dropdown.png" alt="AlFA" class="dropIcon" />
            </div>
          </a>
          <div class="collapse container space-collaps" id="collapseBookingExample">
            <a class="nav-link links-hover" routerLink="new-order" routerLinkActive="active">
              &nbsp; 1- &nbsp;{{'booking.new order' | translate}}</a>
            <a class="nav-link links-hover" routerLink="refund-Booking" routerLinkActive="active">
              &nbsp; 2- &nbsp; {{'booking.Booking' | translate}}
            </a>
            <a class="nav-link links-hover" routerLink="completed-Booking" routerLinkActive="active">
              &nbsp; 3- &nbsp;{{'booking.completed booking' | translate}}</a>
            <a class="nav-link links-hover" routerLinkActive="active" routerLink="contacts">
              &nbsp; 4- &nbsp;{{'requests.contacts' | translate}}
            </a>
            <a class="nav-link links-hover" routerLink="faild-Booking" routerLinkActive="active">
              &nbsp; 5- &nbsp;{{'booking.faildBooking' | translate}}</a>
          </div>
        </li>

        <li *ngIf="role">
          <a class="nav-link links-hover d-flex justify-content-between" data-bs-toggle="collapse"
            href="#collapseTaxesExample" role="button" aria-expanded="false" aria-controls="collapseTaxesExample">
            <div>
              <img src="assets/images/header-icon/commission.svg" class="svg" alt="ALFA">
              <span>{{'taxs.Financial settings' | translate}}</span>
            </div>
            <div>
              <img src="assets/images/header-icon/dropdown.png" alt="AlFA" class="dropIcon" />
            </div>
          </a>
          <div class="collapse container space-collaps" id="collapseTaxesExample">
            <a class="nav-link links-hover" routerLink="health-care-payment" routerLinkActive="active">
              &nbsp; 1- &nbsp; {{'services.Health Care payment' | translate}}
            </a>
            <a *ngIf="role" class="nav-link links-hover" routerLink="taxes" routerLinkActive="active">
              &nbsp; 2- &nbsp; {{ "taxs.app-taxs" | translate }}
            </a>
            <a *ngIf="role" class="nav-link links-hover" routerLink="commision" routerLinkActive="active">
              &nbsp; 3- &nbsp;{{"services.commissions" | translate}}</a>
          </div>
        </li>

        <li *ngIf="role">
          <a class="nav-link links-hover d-flex justify-content-between" data-bs-toggle="collapse"
            href="#collapseLocationExample" role="button" aria-expanded="false" aria-controls="collapseLocationExample">
            <div>
              <img src="assets/images/header-icon/zone.svg" class="svg" alt="location">
              <span>{{'services.location' | translate}}</span>
            </div>
            <div>
              <img src="assets/images/header-icon/dropdown.png" alt="location" class="dropIcon" />
            </div>
          </a>
          <div class="collapse container space-collaps" id="collapseLocationExample">
            <a class="nav-link links-hover" routerLink="city" routerLinkActive="active">
              &nbsp; 1- &nbsp; {{'services.city' | translate}}
            </a>
            <a class="nav-link links-hover" routerLink="zones" routerLinkActive="active">
              &nbsp; 2- &nbsp;{{'services.zone' | translate}}</a>
          </div>
        </li>

        <li>
          <a class="nav-link links-hover d-flex justify-content-between" data-bs-toggle="collapse"
            href="#collapsesettingsExample" role="button" aria-expanded="false" aria-controls="collapsesettingsExample">
            <div>
              <img src="assets/images/Mask Group 89.png" class="svg" alt="alfacare settings">
              <span>{{'notification.alfacaresettings' | translate}}</span>
            </div>
            <div>
              <img src="assets/images/header-icon/dropdown.png" alt="alfacare settings" class="dropIcon" />
            </div>
          </a>
          <div class="collapse container space-collaps" id="collapsesettingsExample">
            <a *ngIf="role" class="nav-link links-hover" routerLink="app-version" routerLinkActive="active">
              &nbsp; 1- &nbsp; {{'version.version' | translate}}
            </a>
            <a *ngIf="marketer" class="nav-link links-hover" routerLink="notification" routerLinkActive="active">
              &nbsp; 2- &nbsp;{{'notification.notification' | translate}}</a>
          </div>
        </li>

        <li *ngIf="role">
          <a class="nav-link links-hover d-flex justify-content-between" data-bs-toggle="collapse"
            href="#collapseFilesExample" role="button" aria-expanded="false" aria-controls="collapseFilesExample">
            <div>
              <img src="assets/images/exports/export data@2x.png" class="svg" alt="files">
              <span>{{'exports.files' | translate}}</span>
            </div>
            <div>
              <img src="assets/images/header-icon/dropdown.png" alt="files" class="dropIcon" />
            </div>
          </a>
          <div class="collapse container space-collaps" id="collapseFilesExample">
            <a class="nav-link links-hover" routerLink="exports" routerLinkActive="active">
              &nbsp; 1- &nbsp; {{'exports.exports' | translate}}
            </a>
            <a class="nav-link links-hover" routerLink="attach-file" routerLinkActive="active">
              &nbsp; 2- &nbsp; {{'exports.new file' | translate}}</a>
          </div>
        </li>

        <li *ngIf="admin">
          <a class="nav-link links-hover d-flex justify-content-between" data-bs-toggle="collapse" href="#collapseOffer"
            role="button" aria-expanded="false" aria-controls="collapseOffer">
            <div>
              <img src="assets/images/header-icon/offers.svg" class="svg" alt="Offer">
              <span>{{'offers.new offer' | translate}}</span>
            </div>
            <div>
              <img src="assets/images/header-icon/dropdown.png" alt="AlFA" class="dropIcon" />
            </div>
          </a>

          <div class="collapse container space-collaps" id="collapseOffer">
            <a class="nav-link links-hover" routerLink="new-offers" routerLinkActive="active">
              &nbsp; 1- &nbsp; {{'offers.marketers offer' | translate}}
            </a>
            <a class="nav-link links-hover" routerLink="marketer-orders" routerLinkActive="active">
              &nbsp; 2- &nbsp; {{'offers.marketer' | translate}}
            </a>
          </div>
        </li>

        <li *ngIf="role">
          <a class="nav-link links-hover d-flex justify-content-between" data-bs-toggle="collapse" href="#collapseOffers"
            role="button" aria-expanded="false" aria-controls="collapseOffers">
            <div>
              <img src="assets/images/header-icon/offers.svg" class="svg" alt="Offer">
              <span>{{'requests.offers' | translate}}</span>
            </div>
            <div>
              <img src="assets/images/header-icon/dropdown.png" alt="AlFA" class="dropIcon" />
            </div>
          </a>

          <div class="collapse container space-collaps" id="collapseOffers">
            <a class="nav-link links-hover" routerLink="service-within-subservice" routerLinkActive="active">
              &nbsp; 1- &nbsp; {{'subservice.serviceInService' | translate}}
            </a>
            <a class="nav-link links-hover" routerLink="services-provided" routerLinkActive="active">
              &nbsp; 2- &nbsp; {{'offers.services company' | translate}}
            </a>
            <a class="nav-link links-hover" routerLink="offer" routerLinkActive="active">
              &nbsp; 3- &nbsp; {{'requests.offers' | translate}}
            </a>
          </div>
        </li>

        <li *ngIf="role">
          <a class="nav-link links-hover" routerLinkActive="active" *ngIf="role" routerLink="admin">
            <img src="assets/images/header-icon/AddAdmin.svg" class="svg" alt="Add Admin">
            <span>{{'services.admin' | translate}}</span>
          </a>
        </li>
        <li *ngIf="role">
          <a class="nav-link links-hover" routerLinkActive="active" routerLink="blogs">
            <img src="assets/images/blogger.png" class="svg" alt="Add blogs">
            <span>{{'blogs.blogs' | translate}}</span>
          </a>
        </li>
        <li *ngIf="role">
          <a class="nav-link links-hover d-flex justify-content-between" data-bs-toggle="collapse"
            href="#collapseGroups" role="button" aria-expanded="false" aria-controls="collapseGroups">
            <div>
              <img src="assets/images/team.png" class="svg" alt="groups">
              <span>{{'groups.groups' | translate}}</span>
            </div>
            <div>
              <img src="assets/images/header-icon/dropdown.png" alt="AlFA" class="dropIcon" />
            </div>
          </a>

          <div class="collapse container space-collaps" id="collapseGroups">
            <a class="nav-link links-hover" routerLink="groups" routerLinkActive="active">
              &nbsp; 1- &nbsp; {{'groups.groups' | translate}}
            </a>
            <a class="nav-link links-hover" routerLink="groups/create-service" routerLinkActive="active">
              &nbsp; * &nbsp; {{'groups.add service' | translate}}
            </a>
          </div>
        </li>

        <li *ngIf="admin_content">
          <a class="nav-link links-hover" routerLinkActive="active" routerLink="existing-users">
            <img src="assets/images/orders/New Order@2x.png" class="svg" alt="Add blogs">
            <span>{{'booking.existing-users' | translate}}</span>
          </a>
        </li>
        
        <li *ngIf="developer">
          <a class="nav-link links-hover" routerLinkActive="active" routerLink="mobile-version">
            <img src="assets/images/header-icon/version.svg" class="svg" alt="Add blogs">
            <span>{{'mob-version.mob-version' | translate}}</span>
          </a>
        </li>
        <li *ngIf="role">
          <a class="nav-link links-hover" routerLinkActive="active" routerLink="payment">
            <img src="assets/images/header-icon/refunding.svg" class="svg" alt="payment">
            <span>{{'payment.payment' | translate}}</span>
          </a>
        </li>
        <li *ngIf="admin">
          <a class="nav-link links-hover" routerLinkActive="active" routerLink="orders">
            <img src="assets/images/blogger.png" class="svg" alt="order">
            <span>{{'order.orders' | translate}}</span>
          </a>
        </li>
        <li class="nav-item my-3">
          <div class="d-flex justify-content-between">
            <p class="address">{{'language.lang' | translate}}</p>
            <div class="mx-2">
              <a (click)="changeCurrentLang('ar')" *ngIf="this.lang.source._value === 'en'" class="py-1 px-1 language"
                data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="lang-name">العربية</span>
                <span class="circle mx-1"></span>
              </a>
              <a (click)="changeCurrentLang('en')" *ngIf="this.lang.source._value === 'ar'" class="py-1 px-1 language"
                data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="lang-name">English</span>
                <span class="circle mx-1"></span>
              </a>
            </div>
          </div>
        </li>
        <li class="nav-item">
          <div>
            <button (click)='isLogout()' mat-menu-item class="bgLang px-2">
              <a data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"
                mat-menu-item class="text-center">{{"Register.logout" |
                translate}}
                <img src="assets/images/Mask Group 56_2022-10-20/Mask Group 56.png"
                  *ngIf="this.lang.source._value == 'en'" class=" mx-2" style="width: 22px;" alt="ALFA">
                <img src="assets/images/Mask Group 56_2022-10-20/Mask Group 56.png"
                  *ngIf="this.lang.source._value == 'ar'" class="arabic-logo mx-2" style="width: 22px;" alt="ALFA"></a>
            </button>
          </div>
        </li>

      </ul>
    </div>
  </div>
</nav>